export const enum FAMILIARISE_STATE {
  RISE_HAND = 'RISE_HAND',
  TRAINER_TOOLS = 'TRAINER_TOOLS',
  SCREEN_SHARE = 'SCREEN_SHARE',
  VIDEO_CONTROLS = 'VIDEO_CONTROLS',
  '3D_OBJECTS' = '3D_OBJECTS',
  SESSION_CHAT = 'SESSION_CHAT',
  STOP_SESSION = 'STOP_SESSION',
}
